module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_null@2x.817bc8b0.png";